import { jsx as _jsx } from "react/jsx-runtime";
import { CarsProvider } from '../components/cars/CarsContext';
import { Cars } from '../components/cars/Cars';
import { BaseController } from './BaseController';
import CarGallery from '../components/CarGallery';
import Swiper from '../components/Swiper';
import CarDetail from '../components/CarDetail';
export class CarsController extends BaseController {
    async renderCarList() {
        console.log("rendering cars list");
        const container = document.getElementById('cars-react');
        const { createRoot } = await import(/* webpackChunkName: "react-dom/client" */ 'react-dom/client');
        if (container) {
            createRoot(container).render(_jsx(CarsProvider, { children: _jsx(Cars, {}) }));
        }
    }
    async renderCar() {
        CarGallery.init();
        Swiper.initDetailGallery();
        Swiper.initCarSlider();
        CarDetail.priceSelect();
        Swiper.initReferenceSlider();
    }
}
